import { Router } from 'vue-router'
import { Store } from 'vuex'
import { State as StoreState } from '@/store/index'
import * as Screen from '@/store/stateScreen'
import ERROR_CODE, { ErrorData } from '@/model/api/error/errorCodeType'
import * as RouterTypeData from '@/model/router/routerType'
import { useRouterUtil } from '@/model/router/router'
import { useStoreAction } from '@/model/store/store'

/**
 * 画面遷移処理取得
 * @returns 画面遷移処理取得関数
 */
const useScreen = () => {
  /**
   * TOP画面に遷移する
   * @param store vuex
   * @param router vue router
   * @param input 入力データ
   * @param error TOP画面に表示するエラー情報
   */
  const topRedirectByError = async (
    store: Store<StoreState>,
    router: Router,
    input: RouterTypeData.LoginTopData,
    error: ErrorData
  ) => {
    // TOP画面遷移情報設定
    const data: Screen.Top = {
      username: '',
      auth: false, // TOP画面では認証不要のためfalseにする
      error: {
        data: [
          {
            code: error.code,
            key: error.key,
            arg: [],
          },
        ],
      },
    }
    // TOP画面情報更新
    await useStoreAction(store).topRedirect(data)
    // TOP画面に遷移する
    useRouterUtil(router).top(input)
  }

  /**
   * TOP画面に遷移する(認証後の画面から遷移)
   * @param store  vuex
   * @param router vue router
   * @param input 入力データ
   */
  const topRedirect = async (store: Store<StoreState>, router: Router, input: RouterTypeData.LoginTopData) => {
    // TOP画面遷移後の認証切れ設定
    const error = ERROR_CODE.AUTH.EXPIRED
    const data: ErrorData = {
      code: error.code,
      key: error.key,
    }
    topRedirectByError(store, router, input, data)
  }

  /**
   * TOP画面に遷移する(認証前の画面から遷移)
   * @param store  vuex
   * @param router vue router
   */
  const topRedirectNoauth = async (store: Store<StoreState>, router: Router) => {
    // TOP画面遷移後の予期せぬ動作設定
    const error = ERROR_CODE.SYSTEM.UNEXPECTED
    const data: ErrorData = {
      code: error.code,
      key: error.key,
    }
    // TOP画面の遷移情報は空
    const input: RouterTypeData.LoginTopData = {}
    topRedirectByError(store, router, input, data)
  }

  /**
   * TOP画面に遷移する 本関数はTOP画面にエラー情報は表示しない
   * @param store vuex
   * @param router vue router
   * @param input 入力データ
   */
  const topRedirectNormal = async (store: Store<StoreState>, router: Router, input?: RouterTypeData.LoginTopData) => {
    // TOP画面遷移情報設定
    const data: Screen.Top = {
      username: '',
      auth: false, // TOP画面では認証不要のためfalseにする
      error: {
        data: [], // エラー情報は空にする
      },
    }
    // TOP画面情報更新
    await useStoreAction(store).topRedirect(data)
    // TOP画面に遷移する
    // 入力データが指定されていない場合はリダイレクト情報無しのデータを渡す
    const topdata: RouterTypeData.LoginTopData = input !== undefined ? input : {}
    useRouterUtil(router).top(topdata)
  }

  return {
    topRedirect,
    topRedirectNoauth,
    topRedirectNormal,
  }
}

export { useScreen }
